module.exports = __webpack_public_path__ + "assets/images/artist1.09ad9510.jpg";